import { IDatasourceSQLMap } from 'src/app/utils/datasource-sql-map/datasource';

export class BiCorePlayerDimsSqlMap {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_core',
        tableId: 'player_dims',
        columns: {},
    };
}
